<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-pass`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_b9cc392844__clip0_5692_15855)"><path d="M7.99951 0.835938C11.9566 0.835938 15.1646 4.04386 15.1646 8.00098C15.1645 11.9581 11.9566 15.166 7.99951 15.166C4.04263 15.1658 0.834522 11.9579 0.834473 8.00098C0.834473 4.04401 4.0426 0.836185 7.99951 0.835938ZM7.99951 2.16602C4.77714 2.16626 2.16455 4.77855 2.16455 8.00098C2.1646 11.2234 4.77717 13.8357 7.99951 13.8359C11.2221 13.8359 13.8344 11.2235 13.8345 8.00098C13.8345 4.7784 11.2221 2.16602 7.99951 2.16602ZM10.4634 5.58789C10.7231 5.32867 11.1443 5.32932 11.4038 5.58887C11.6628 5.84863 11.6623 6.26985 11.4028 6.5293L7.51807 10.4141C7.25849 10.6735 6.83732 10.6733 6.57764 10.4141L4.59619 8.43359C4.33667 8.17408 4.33704 7.75291 4.59619 7.49316C4.85589 7.23347 5.27692 7.23347 5.53662 7.49316L7.04834 9.00293L10.4634 5.58789Z"/></g><defs><clipPath id="svg_b9cc392844__clip0_5692_15855"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconLinePass',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
